module.exports = __webpack_public_path__ + "img/mint-now-gaia.8ed98b3d.png";